import { createSelector } from 'reselect';
import merge from 'lodash/merge';

export const selectErrorMessage = state => state.errorMessage;

export const selectErrorMessageConfig = createSelector(
  selectErrorMessage,
  errorMessage => errorMessage.config,
);

// A smart merging of the final error message and title:
// - A smallest priority has a 'config.errorMessages.default' set in core config. Could be overriden in org config.
//   If no related message for the provided error code if found in 'config.errorMessages' then this value will be used.
// - Next priority has an actual error code related message set in core 'config.errorMessages[code]' object if found.
//   Could be overriden in org config.
// - Next higher priority has the 'config.errorMessages.custom' set in core config. Could be overriden in org config.
//   If the 'title' or 'message' values exists it will override the default and the code specific values from config.
// - The highest priority has the 'errorData' store object. Its data is saved into module's store directly from the
//   'window.errorData' object generated by smarty if it has the 'title' or 'message' values.
export const selectErrorMessageMergedData = createSelector(
  selectErrorMessage,
  (errorMessage) => {
    const { errorData, config: { errorMessages } } = errorMessage;
    return merge({}, errorMessages.default, errorMessages[errorData.code], errorMessages.custom, errorData);
  },
);

export const selectShouldRenderErrorCode = createSelector(
  selectErrorMessageMergedData,
  selectErrorMessageConfig,
  (errorData, config) => config.showErrorCodes.includes(errorData.code),
);

export const selectErrorMessageCode = createSelector(
  selectErrorMessageMergedData,
  errorData => errorData.code,
);

export const selectErrorMessageTitle = createSelector(
  selectErrorMessageMergedData,
  errorData => errorData.title,
);

export const selectErrorMessageText = createSelector(
  selectErrorMessageMergedData,
  errorData => errorData.message,
);
